module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-337.e1f9672.woff2";